import { GetterTree } from 'vuex';
import { Group, GroupsState } from '@/store/groups/types';
import { RootState } from '@/store/types';

const getters : GetterTree<GroupsState, RootState> = {
  /**
   * グループIDを元にグループ情報を取得
   * @param {string} groupId グループID
   */
  findGroupById: (state) => (groupId: string): Group|null => {
    return state.groups.find((group: Group) => group.id === groupId) || null
  },
}

export default getters;
